<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div style="overflow: auto">
      <table
        style="
          border-collapse: collapse;
          border-color: #ebeef5;
          font-size: 14px;
          color: #606266;
        "
        cellpadding="20"
        border="1"
      >
        <thead>
          <th style="white-space: nowrap; color: #909399">明细类目</th>
          <th
            style="white-space: nowrap; color: #909399"
            v-for="item in state.sortFields"
            :key="item"
          >
            {{ item.name }}
          </th>
        </thead>
        <tbody>
          <tr v-for="item in state.tableData" :key="item">
            <td style="white-space: nowrap">{{ item.typeName }}</td>
            <td
              style="white-space: nowrap"
              v-for="field in state.sortFields"
              :key="field"
            >
              {{ item[field.field] || "-" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { recalctaxemployee_detail } from "@/http/recalctaxemployee";

export default {
  props: {
    id: Number,
  },
  setup(props) {
    const state = reactive({});
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      recalctaxemployee_detail(props.id).then((res) => {
        if (res.status == 200) {
          const { info, sortFields } = res.data.data;
          state.tableData = [
            { typeName: "历史算税明细", ...info.re_tax_data },
            { typeName: "复核算税明细", ...info.tax_data },
          ];
          state.sortFields = sortFields;
        }
      });
    };
    return { state, props };
  },
};
</script>
<style scoped></style>
